import React, { Component } from "react";
import getDates from "../../shared/services/date.service";
import styles from "./connectionItem.module.scss";
import ConnectionDataItem from "./ConnectionDataItem";
import { uuid } from "uuidv4";

class ConnectionItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      item: JSON.parse(JSON.stringify(props.item)),
    };
  }

  getTypeTitle(type) {
    switch (type) {
      case 0:
        return "Неизвестный";
      case 1:
        return "Tn12/24";
      case 2:
        return "Teltonica";
      case 3:
        return "Umka";
      case 4:
        return "SeeWorld";
      default:
        return "Неизвестный";
    }
  }

  render() {
    const { item } = this.state;
    const { isOpen } = this.props;

    return <ConnectionDataItem key={isOpen} data={item} isOpen={isOpen} isViewPoints={this.props.isViewPoints} />;
  }
}

export default React.memo(ConnectionItem);
